var map = {
	"./dice1@1.5x.png": 3520,
	"./dice2@1.5x.png": 3521,
	"./dice3@1.5x.png": 3522,
	"./dice4@1.5x.png": 3523,
	"./dice5@1.5x.png": 3524,
	"./dice6@1.5x.png": 3525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3519;